import { createConfigParametersRepository } from '../../../configParametersRepository';
import { createRuntimeState } from '../../../configParametersRepository/state';
import { recoverStoredEvents } from '../../thirdPartyTrackingAgent/eventStore';
import { handleConsent } from './consent';
import { setupAnalyticsSession } from './init';

export const initGoogleAnalytics = async () => {
  await setupAnalyticsSession();
  recoverStoredEvents();
  handleConsent();
};

let deferredPromise: Promise<void> | null = null;
export const checkGaInit = async () => {
  const { getTrackingStorageClient, getGenericParameters } =
    createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const { visitID } = getGenericParameters() || {};
  const { getRuntimeState } = createRuntimeState();
  const { isStorageInitialized } = getRuntimeState();
  if (deferredPromise !== null) {
    return deferredPromise;
  }
  if (!isStorageInitialized) {
    storageClient?.initThirdParty(visitID);
  }
  deferredPromise = initGoogleAnalytics();
  await deferredPromise;
};

/**
 * For testing purposes only
 */
export const resetDeferredPromise = () => {
  deferredPromise = null;
};
